import React from 'react';
import { BaseComponent } from '../../../../components/BaseComponent';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../../components/Box';
import { DocumentsList } from '../../../Documents/components/documentsList';
import { Button } from '../../../../components/Buttons';
import { selectWorks, selectWork } from '../../../Api/selectors';
import { Loader } from '../../../../components/Loader';
import { forceKanbanCacheRefresh } from '../../actions';
import { REQUEST_KANBAN_BOARD_COLUMN_CELLS } from '../../constants';
import { REQUEST_ADD_DOCUMENT, REQUEST_COMPANY, INITIATE_COMPANY_EDIT } from '../../../Companies/constants';

const Container = styled.div`
  width: 100%;

  .field-block {
    // white-space: nowrap;
    margin-bottom: 8px;
    .label {
      width: 60%;
    }
  }

  .req-doc-wrapper {
    width: 100%;
   // border: 1px solid red;
    padding-right: 10px;
  }
`;

const STATE = {
  string: null,
  result: null,
  address: {},
};

/* eslint-disable react/prefer-stateless-function */
class CompanyKYCDocumentsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.forceCacheRefresh();
  }

  componentDidUpdate(prevProps, prevState) {}

  get company() {
    return this.props.company;
  }

  save() {
    this.props.onSave();
  }

  reset() {
    this.props.onCancel();
  }

  renderDocumentsField() {
    return (
      <>
        {this.company?.documents?.map(document => {
          if (this.props.documents.includes(document.entityType)) {
            return <DocumentsList DocumentsList entityId={this.company?.id} entityType="company" items={[document]} />;
          }

          return <Button upload></Button>;
        })}
      </>
    );
  }

  render() {
    if (this.props.work || this.props.workDocs) return <Loader small />;
    return (
      <Container>
        {this.props.documents?.map(requiredDoc => {
          const document = this.company?.documents?.find(doc => doc?.originalFilename == requiredDoc);
          return (
            <HBox key={requiredDoc} vCenter className={'field-block'}>
              <strong className={'label'}>{this.lbl(`company.details.documents.fields.${requiredDoc}`)}</strong>
              {document ? (
                <div style={{ width: '100%' }}>
                  <DocumentsList DocumentsList kanban entityId={this.company?.id} entityType="company" items={[document]} />
                </div>
              ) : (
                <div key={requiredDoc} className="req-doc-wrapper">
                  <DocumentsList
                    DocumentsList
                    label={this.props.locationScreen && this.lbl('documents.upload.upload_print_screen_of_location')}
                    singleType={requiredDoc}
                    entityId={this.company?.id}
                    entityType="company"
                    items={[]}
                  />
                </div>
              )}
            </HBox>
          );
        })}
      </Container>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_COMPANY, `${REQUEST_COMPANY}-${ownProps.company?.id}`, INITIATE_COMPANY_EDIT]),
    workDocs: selectWork(REQUEST_ADD_DOCUMENT),
    // work: selectWorks([`${REQUEST_KANBAN_BOARD_COLUMN_CELLS}${ownProps.board_id}_${ownProps.column?.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    forceCacheRefresh() {
      dispatch(forceKanbanCacheRefresh(ownProps.board_id, ownProps.column.id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyKYCDocuments = compose(withConnect, withRouter)(CompanyKYCDocumentsComp);
